var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      class: _vm.displaySectionSeparated ? "mb-6" : "",
      attrs: { outlined: "", rounded: "lg" },
    },
    [
      _c(
        "div",
        {
          staticClass: "pa-4",
          attrs: { id: `gc-section-wrapper-${_vm.sectionId}` },
          on: {
            mouseenter: function ($event) {
              _vm.showToolbar = true
            },
            mouseleave: function ($event) {
              _vm.showToolbar = false
            },
          },
        },
        [
          _vm.renderToolbar
            ? _c("content-section-toolbar", {
                attrs: {
                  sectionId: _vm.contentSection.sectionId,
                  visible: _vm.showToolbar,
                  contentRestrictions: _vm.contentSection.contentRestrictions,
                },
                on: {
                  copy: _vm.copyTextClicked,
                  bookmark: _vm.bookmarkClicked,
                  print: _vm.printClicked,
                  share: _vm.shareClicked,
                  fireMobileActions: _vm.mobileActionClicked,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "highlightable",
              staticClass: "highlightable",
              attrs: { tabindex: "0" },
            },
            [
              _c(
                "button",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value:
                        _vm.fromHighlight.showButton &&
                        _vm.fromHighlight.action,
                      expression:
                        "fromHighlight.showButton && fromHighlight.action",
                    },
                  ],
                  ref: "addNoteButtonFromHighlight",
                  staticClass:
                    "add-note-button v-btn primary v-btn--flat v-btn--outlined theme--dark v-size--default",
                  style: {
                    top: _vm.fromHighlight.buttonTop + "px",
                    left: _vm.fromHighlight.buttonLeft + "px",
                  },
                  on: { click: _vm.handleHighlightButtonClick },
                },
                [
                  _vm.fromHighlight.buttonIcon
                    ? _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { dark: "" } },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.fromHighlight.buttonIcon) +
                              "\n                "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.fromHighlight.buttonText) +
                      "\n            "
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("content-section-title", {
                attrs: {
                  title: _vm.contentSection.title,
                  contentId: _vm.contentSection.sectionId,
                  documentId: _vm.contentSection.documentId,
                  isLink: _vm.showTitleAsLink && _vm.isLink(_vm.contentSection),
                },
              }),
              _vm._v(" "),
              _c("content-section-content", {
                attrs: {
                  content: _vm.contentSection.content,
                  documentId: _vm.contentSection.documentId,
                  sectionId: _vm.contentSection.sectionId,
                  contentModifiers: _vm.contentModifiers,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("content-section-insights"),
          _vm._v(" "),
          _vm.contentSection?.contentRestrictions?.canBookmark
            ? _c("content-section-user-bookmarks", {
                attrs: {
                  defaultSortOrder: _vm.userBookmarksDefaultSortOrder,
                  expandSection: _vm.isNotesSectionExpanded,
                  bookmarks: _vm.contentSection.bookmarks,
                  sectionId: _vm.contentSection.sectionId,
                  defaultShowAll: _vm.showAllBookmarks,
                  showNoteControlMenu: _vm.showNoteControlMenu,
                },
                on: {
                  sectionSortOrderChanged: function ($event) {
                    return _vm.$emit("sectionSortOrderChanged", $event)
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.displayBreadCrumbs &&
          _vm.contentSection?.breadcrumbs?.length !== 0
            ? _c("content-section-breadcrumb", {
                attrs: { breadcrumbs: _vm.contentSection?.breadcrumbs },
                on: { "breadcrumb-clicked": _vm.handleBreadcrumbClick },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }